import { ISchemaError } from "../interfaces/ISchemaError/ISchemaError";
import { z } from "zod";

export const createdBySchema = z.string({ invalid_type_error: ISchemaError.CREATED_BY_INVALID_TYPE }).default("");
